import React from 'react';
import { Link } from 'react-router-dom';

export function FooterSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="border-t border-[#800020] pt-8">
          <Link to="/">
            <img
              src="https://i.ibb.co/ZKF53B4/TEZHLY-9.png"
              alt="TEZHLY"
              className="h-12 w-auto"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                target.insertAdjacentHTML('afterend', '<span class="text-2xl font-bold text-[#800020]">TEZHLY</span>');
              }}
            />
          </Link>
        </div>
      </div>
    </section>
  );
}